var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.725 14L10 11.6889L12.275 14L13.5 12.7556L11.225 10.4444L13.5 8.13333L12.275 6.88889L10 9.2L7.725 6.88889L6.5 8.13333L8.775 10.4444L6.5 12.7556L7.725 14ZM5.625 18C5.14375 18 4.73192 17.8261 4.3895 17.4782C4.0465 17.1298 3.875 16.7111 3.875 16.2222V4.66667H3V2.88889H7.375V2H12.625V2.88889H17V4.66667H16.125V16.2222C16.125 16.7111 15.9538 17.1298 15.6114 17.4782C15.2684 17.8261 14.8562 18 14.375 18H5.625ZM14.375 4.66667H5.625V16.2222H14.375V4.66667Z",
    fill: "#151B25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/DeleteSVG.5c38d3bdd14823c215be070ad98e17e0.svg";
export { ForwardRef as ReactComponent };